export const REG_EXP_ONE_LOWERCASE = /(?=.*[a-z])/;
export const REG_EXP_ONE_UPPERCASE = /[A-Z]/;
export const REG_EXP_SPECIAL_CHARACTER = /(?=.*[!@#$%^&*])/;
export const REG_EXP_NUMBER = /\d/;
export const REG_EXP_MINIMUM_EIGHT_CHARACTERS = /.{8,}/;
export const PASSWORD_VALIDATION_REG_EXP = new RegExp(`^${REG_EXP_ONE_LOWERCASE.source}${REG_EXP_ONE_UPPERCASE.source}${REG_EXP_NUMBER.source}${REG_EXP_SPECIAL_CHARACTER.source}${REG_EXP_MINIMUM_EIGHT_CHARACTERS.source}`);